import { Attendee } from '../shared/attendee.model';

export class ProjectAttendee extends Attendee {
    motivation: string;
    primaryCommunityId: string;
}
